// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6894) return "static/chunks/6894-d279aeffc5af24a4.js";
	if (chunkId === 5720) return "static/chunks/5720-c834058cabfb70f9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"769":"9026e456ca8731af","7650":"15030f51f20631a2","9191":"a08d1956cb278846"}[chunkId] + ".js";
};